<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert
      v-if="is_premium"
      dense text
      class="body-2 mb-5"
      type="info"
    >
      Berikut ini merupakan data kategori keterlambatan, yang di dalamnya
      mengatur mengenai rentan waktu yang dianggap terlambat.
      <b>Klik tombol tambah (+)</b> untuk <b>menambahkan Kategori</b> baru.
    </v-alert>
    <m-card-list
      two-line
      class="pt-5"
      title="Kelola Kategori Keterlambatan"
      label-cari="Cari Kategori Keterlambatan"
      :add="isCan(`skor-presensi.${keyAkses}store`)"
      edit
      search
      :items="items"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
            search => {
              textSearch = search;
              load();
            }
          "
      @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
      @add="add"
    >
      <template v-slot:items="{ item }">
        <v-row class="mx-3 mt-3">
          <v-col cols="10" sm="10" md="10" lg="10">
            <v-row>
              <v-col class="py-0" cols="12" md="4" sm="4">
                <p class="caption my-0 py-0 grey--text align-left">Nama</p>
                {{ pVal(item, "nama") }}
                <span v-if="item.angkatan"
                >({{ pVal(item, "angkatan") }})
                    </span>
                <template v-if="+item.is_skor_absen === 1">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="green" v-bind="attrs" v-on="on">
                        mdi-check-circle
                      </v-icon>
                    </template>
                    <span>Penanda Tidak Hadir Sama Sekali</span>
                  </v-tooltip>
                </template>
              </v-col>
              <v-col class="py-0" cols="12" md="4" sm="4">
                <p class="caption my-0 py-0 grey--text align-left">
                  Rentang Waktu Terlambat
                </p>
                {{ pVal(item, "batas_bawah") }} -
                {{ pVal(item, "batas_atas") }}
              </v-col>
              <v-col class="py-0" cols="12" md="2" sm="2">
                <p class="caption my-0 py-0 grey--text align-left">
                  Persentase
                </p>
                {{ pVal(item, "skor") }} %
              </v-col>
              <v-col class="py-0" cols="12" md="2" sm="2">
                <p class="caption my-0 py-0 grey--text align-left">
                  Satuan
                </p>
                {{ pVal(item, "satuan") }}
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2" sm="2" lg="1" md="1">
            <m-menu
              v-if="isCan(`skor-presensi.${keyAkses}update`) ||
                        isCan(`skor-presensi.${keyAkses}destroy`) ||
                        isCan(`skor-presensi.update-skor-tmk`)"
              right
              class="clearfix"
              style="float:right"
              :items="more_menu"
              :object="item"
            />
          </v-col>
        </v-row>
        <v-divider class="mt-3"></v-divider>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Tanggal Awal", align: "left", value: "tgl_mulai" },
        { text: "Tanggal Akhir", align: "left", value: "tgl_akhir" },
        { text: "", align: "left", sortable: false }
      ],
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] }
      },
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: () => isCan(`skor-presensi.${this.keyAkses}update`)
        },
        {
          title: "Set Master",
          click: (i, o) => this.setMaster(o),
          check: (i, o) => o.is_skor_absen === 0 && isCan(`skor-presensi.update-skor-tmk`)
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: () => isCan(`skor-presensi.${this.keyAkses}destroy`)
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("kategoriTerlambat/get", {
          organisasi_id: this.organisasi_id || this.tenant_id,
          params: {
            page: this.cp,
            keyword: this.textSearch
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
            </div>
        </div>

        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.nama}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch("kategoriTerlambat/drop", {
            organisasi_id: this.organisasi_id || this.tenant_id,
            skor_presensi_id: item.skor_presensi_id
          })
        )
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    setMaster(item) {
      this.$confirm(
        "Apakah Anda yakin ingin meng-aktifkan penanda tidak hadir sama sekali ? ",
        {},
        "Set Penanda Tidak Hadir Sama Sekali",
      )
        .then(() =>
          this.$store.dispatch("kategoriTerlambat/setMaster", {
            organisasi_id: this.organisasi_id || this.tenant_id,
            skor_presensi_id: item.skor_presensi_id
          })
        )
        .then(() => {
          this.$info("Aksi berhasil dilakukan");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
